import { recordApiError } from './recentErrors';
/**
 * The hospital the user is working in, sent to the API as X-Organization-Id.
 * - Staff in several hospitals/branches pick one with the switcher.
 * - A superadmin in "support view" looks at one hospital read-only.
 */
export interface ActiveOrganization {
  id: string;
  name: string;
  support?: boolean;
}

const KEY = 'medease.activeOrg';

export const getActiveOrganization = (): ActiveOrganization | null => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as ActiveOrganization) : null;
  } catch {
    return null;
  }
};

export const setActiveOrganization = (org: ActiveOrganization) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(org));
  } catch {
    // Private mode: the primary hospital is used
  }
};

export const clearActiveOrganization = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
};

/** Switch hospital and reload so every cached query refetches for the new one. */
export const switchOrganization = (org: ActiveOrganization | null, to = '/') => {
  if (org) setActiveOrganization(org);
  else clearActiveOrganization();
  window.location.assign(to);
};

/**
 * Server refusals that the user should always see (read-only support view, suspended
 * hospital, expired plan). Raised from the HTTP clients, shown by <ApiNotices />.
 */
export const API_NOTICE_EVENT = 'medease:api-notice';

export const reportApiNotice = (error: any) => {
  recordApiError(error);
  const status = error?.response?.status;
  const message = error?.response?.data?.error;
  if ((status === 402 || status === 403) && typeof message === 'string') {
    window.dispatchEvent(new CustomEvent(API_NOTICE_EVENT, { detail: { status, message } }));
  }
};
